import { Injectable } from '@angular/core';
import {environment} from "../../../../environments/environment";
import {map, Observable} from "rxjs";
import {HttpClient, HttpParams} from "@angular/common/http";



@Injectable({
  providedIn: 'root'
})
export class CertificateService {
  baseURL = environment.baseUrl + 'certificate';

  constructor(private http: HttpClient) {
  }

  getAllCertificates(eventId:any): Observable<any> {
    return this.http.get<any>(`${this.baseURL}/event/${eventId}`)
  }

  uploadCertificates(formData: FormData, eventId: any): Observable<any> {
    return this.http.post<any>(`${this.baseURL}/event/${eventId}`, formData).pipe(
      map((res: any) => res)
    );
  }

  deleteCertificate(eventId:any,certId:number,certName:string){
    const params = new HttpParams()
      .set('certName', certName)
    return this.http.delete<any>(`${this.baseURL}/event/${eventId}/certificate/${certId}`,{params})
  }
}
